import { message } from "antd";
import { store } from "../Store/Store";
import { logout } from "../Store/authStore";
import {
  APIResponseErrorCodes,
  APIResponseStatus,
  MessageKeys,
} from "../Constants/Constants";

/**
 * @param {*} history : history prop of component
 * @param {*} preProcess : process to be done at start of api callback
 * @param {*} errorCallback : callback function in case of error
 * @param {*} failCallback : callback function in case of failure
 * @param {*} successCallback : callback function in case of success
 */
export const apiCallback =
  ({ preProcess, failCallback, errorCallback, successCallback }) =>
  (error, data, _) => {
    console.log("apiCallback", data, error);
    message.destroy(MessageKeys.apiError);
    preProcess && preProcess();
    if (error) {
      const apiRes = error.response;
      if (apiRes?.status === 401) {
        const res = JSON.parse(apiRes?.text || "{}");
        console.log("Error response", apiRes, res);
        if (res.info?.includes(APIResponseErrorCodes.sessionExpired)) {
          message.error({
            key: MessageKeys.apiError,
            content: "Session expired. Please logout and login again.",
            duration: 0,
          });
        } else {
          message.error({
            key: MessageKeys.apiError,
            content: res.info
              ? "Something went wrong:" + res.info
              : "You're not authorized for this action!",
            duration: 0,
          });
        }
        // store.dispatch(logout());
        // history?.push("/login");
      } else {
        const res = JSON.parse(apiRes?.text || "{}");
        if (failCallback && res?.status === APIResponseStatus.fail) {
          failCallback(error);
        } else {
          errorCallback && errorCallback(error);
        }
      }
    } else {
      if (failCallback && data?.status === APIResponseStatus.fail) {
        failCallback(data);
      } else {
        successCallback && successCallback(data);
      }
    }
  };

/**
 * @param {*} props : props of component
 * @param {*} recordName : name of record for which status changed
 * @param {*} errorRollback : rollback function in case of error
 * @returns
 */
export const statusChangeApiCallback = ({
  props: { history },
  recordName,
  errorRollback,
}) => {
  const errorCallback = (data) => {
    const errorInfo = data?.info ? ": " + data.info : "";
    message.error(`Error changing status of ${recordName}` + errorInfo);
    errorRollback && errorRollback();
  };
  const successCallback = (data) => {
    if (data?.status === APIResponseStatus.fail) {
      errorCallback(data);
    } else {
      message.success(`Status changed successfully for ${recordName}`);
    }
  };
  return apiCallback({ history, errorCallback, successCallback });
};
